export default __webpack_public_path__ + "static/media/chauffe-eau.579e6aa1.svg";